import { BookOpen, ArrowRight } from 'lucide-react';
import type { SlotComponentProps } from '../../types';

const InformationalKnowledgeBlock = ({ emitSignal }: SlotComponentProps) => {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-100 text-blue-700">
          <BookOpen className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-slate-900">Knowledge-first layout</h2>
          <p className="text-sm text-slate-500">The system is currently optimizing for understanding before execution.</p>
        </div>
      </div>

      <div className="grid gap-3 md:grid-cols-3">
        <div className="rounded-2xl bg-slate-50 p-4">
          <p className="text-sm font-semibold text-slate-900">Overview</p>
          <p className="mt-2 text-sm text-slate-600">Render condensed documentation, visual summaries, and key terms.</p>
        </div>
        <div className="rounded-2xl bg-slate-50 p-4">
          <p className="text-sm font-semibold text-slate-900">Decision support</p>
          <p className="mt-2 text-sm text-slate-600">Expose relevant signals while deferring forms until readiness increases.</p>
        </div>
        <div className="rounded-2xl bg-slate-50 p-4">
          <p className="text-sm font-semibold text-slate-900">Adaptive prompt</p>
          <p className="mt-2 text-sm text-slate-600">Detect readiness and swap the layout to an execution-oriented variant.</p>
        </div>
      </div>

      <button
        onClick={() =>
          emitSignal({
            type: 'ready-to-execute',
            timestamp: Date.now(),
            metadata: { source: 'informational-cta' },
          })
        }
        className="mt-5 inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
      >
        I’m ready to take action
        <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default InformationalKnowledgeBlock;